import { createRouter, createWebHistory } from 'vue-router'
import DashboardView from '../views/DashboardView.vue'
import LoginView from '../views/auth/Login.vue'
import ForgetView from '../views/auth/Forget.vue'
import SignupView from '../views/auth/Signup.vue'
import ResetView from '../views/auth/Reset.vue'
import DraftOrderView from '../views/DraftOrderPage.vue'
// import EmailVerificationView from '../views/auth/EmailVerification.vue'
import PaymentView from '../views/PaymentPage.vue'
// import NewPaymentView from '../views/NewPaymentPage.vue'
import ProductView from '../views/ProductPage.vue'
// import NewProductView from '../views/NewProductPage.vue'
import OrderView from '../views/OrderPage.vue'
import OrderDetailView from '../views/OrderDetailPage.vue'
import UserProfileView from '../views/UserProfilePage.vue'
import BillingView from '../views/BillingPage.vue'
import BillingInvoiceView from '../views/BillingInvoicePage.vue'
import OpenInvoicesView from '../views/OpenInvoicesPage.vue'
import InvoiceViewPage from '../views/InvoiceViewPage.vue'
import UsersView from '../views/UsersPage.vue'
import AddUserView from '../views/AddUserPage.vue'
import UserInvitationView from '../views/UserInvitationPage.vue'
import ByDomainView from '../views/reports/DomainPage.vue'
import ByDomainDetailView from '../views/reports/DomainDetailPage.vue'
import ByOrderView from '../views/reports/OrderPage.vue'
import ByOrderDetailView from '../views/reports/Order_DetailPage .vue'
import ByDestinationView from '../views/reports/DestinationPage.vue'
import ByDestinationListView from '../views/reports/DestinationListPage.vue'
import MaintenanceView from '../views/503Page.vue'
import NotFoundView from '../views/notFoundPage.vue'
import MissedOpportunityView from '../views/MissedOpportunityPage.vue'
import MissedOpportunityOrderView from '../views/MissedOpportunityOrderPage.vue'
import PackagesView from '../views/packages/PackagesPage.vue'
import DigitalPrView from '../views/DigitalPrPage.vue'
import EnterpriseView from '../views/EnterprisePage.vue'
import AllAffiliateStatsView from '../views/AllAffiliateStatsView.vue'
import CreateAffiliateUrl from '../views/CreateAffiliateUrl.vue'
import EditedOrderView from '../views/EditedOrderPage.vue'
import EditedOrderLinksView from '../views/EditedOrderLinksPage.vue'
import EditedOrderPaymentView from '../views/EditedOrderPaymentPage.vue'
import MediaLinksView from '../views/MediaLinksViewPage.vue'
import MediaLinksSummaryView from '../views/MediaLinksSummaryPage.vue'
import InvoicePaymentView from '../views/InvoicePaymentPage.vue'


import store from '@/store';
import { getRefFromQuery, isAuthPath, withRouteRef } from '@/utils/affiliateRef';

const routes = [
  {
    path: "/dashboard",
    redirect: "dashboard",
    meta: { isAuthRequired: true },
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        meta: { title: 'Dashboard' },
        component: DashboardView
      },
      {
        path: '/draft-order',
        name: 'draft-order',
        meta: { title: 'Draft Orders' },
        component: DraftOrderView
      },
      {
        path: '/order-summary',
        name: 'order-summary',
        meta: { title: 'Order Summary' },
        component: PaymentView
      },
      {
        path: '/edited-order-summary',
        name: 'edited-order-summary',
        meta: { title: 'Edited Order Summary' },
        component: EditedOrderPaymentView
      },
      {
        path: '/product/:id?',
        name: 'product',
        meta: { title: 'Products' },
        component: ProductView
      },
      // {
      //   path: '/new-product/:id?',
      //   name: 'new-product',
      //   meta: { title: 'New Products' },
      //   component: NewProductView
      // },
      {
        path: '/order/:id?',
        name: 'order1',
        meta: { title: 'Orders' },
        component: OrderView
      },
      {
        path: '/order-detail/:id',
        name: 'order-detail',
        meta: { title: 'Order Detail' },
        component: OrderDetailView
      },
      {
        path: '/user-profile',
        name: 'user-profile',
        meta: { title: 'Profile' },
        component: UserProfileView
      },
      {
        path: '/order-receipts',
        name: 'order-receipts',
        meta: { title: 'Order Receipts' },
        component: BillingView
      },
      {
        path: '/billing',
        redirect: '/order-receipts'
      },
      {
        path: '/invoices',
        name: 'invoices',
        meta: { title: 'Invoices' },
        component: OpenInvoicesView
      },
      {
        path: '/invoice-view/:id',
        name: 'invoice-view',
        meta: { title: 'Invoice' },
        component: InvoiceViewPage
      },
      {
        path: '/open-invoices',
        redirect: '/invoices'
      },
      {
        path: '/invoice/:id',
        name: 'billing-Invoice',
        meta: { title: 'Receipt' },
        component: BillingInvoiceView
      },
      {
        path: '/users',
        name: 'users',
        meta: { title: 'User Management' },
        component: UsersView
      },
      {
        path: '/add-user/:id?',
        name: 'add-user',
        meta: { title: 'Add New User' },
        component: AddUserView
      },

      {
        path: '/domain',
        name: 'domain',
        meta: { title: 'Agency Reports - By Domain' },
        component: ByDomainView
      },

      {
        path: '/domain-detail/:domain',
        name: 'domain-detail',
        meta: { title: 'Domain Name' },
        component: ByDomainDetailView
      },

      {
        path: '/byorder',
        name: 'order',
        meta: { title: 'Agency Reports - By Order' },
        component: ByOrderView
      },

      {
        path: '/report-order-detail/:id',
        name: 'report-order-detail',
        meta: { title: 'Order ID' },
        component: ByOrderDetailView
      },

      {
        path: '/destination',
        name: 'destination',
        meta: { title: 'Agency Reports - By Destination' },
        component: ByDestinationView
      },

      {
        path: '/destination-list/:destination',
        name: 'destination-list',
        meta: { title: 'Destination List' },
        component: ByDestinationListView
      },

      {
        path: '/missed-opportunity',
        name: 'missed-opportunity',
        meta: { title: 'Premium Placements' },
        component: MissedOpportunityView
      },

      {
        path: '/missed-opportunity-order/:id?',
        name: 'missed-opportunity-order',
        meta: { title: 'Premium Placements' },
        component: MissedOpportunityOrderView
      },

      {
        path: '/packages',
        name: 'packages',
        meta: { title: 'Packages' },
        component: PackagesView
      },

      {
        path: '/digitalpr',
        name: 'digitalpr',
        meta: { title: 'Digitalpr' },
        component: DigitalPrView
      },
      {
        path: '/media-links',
        name: 'media-links',
        meta: { title: 'Media Links' },
        component: MediaLinksView
      },
      {
        path: '/media-links-summary/:id?',
        name: 'media-links-summary',
        meta: { title: 'Media Links Summary' },
        component: MediaLinksSummaryView
      },
      {
        path: '/brand-mentions',
        name: 'brand-mentions',
        meta: { title: 'Brand Mentions' },
        component: () => import('../views/BrandMentionsPage.vue')
      },
      {
        path: '/brand-mentions/checkout',
        name: 'brand-mentions-checkout',
        meta: { title: 'Brand Mentions Checkout' },
        component: () => import('../views/BrandMentionCheckoutPage.vue')
      },
      {
        path: '/enterprise',
        name: 'enterprise',
        meta: { title: 'Enterprise' },
        component: EnterpriseView
      },

      {
        path: '/affiliate',
        name: 'affiliate',
        meta: { title: 'Affiliate' },
        component: AllAffiliateStatsView
      },
      {
        path: '/affiliate-url',
        name: 'affiliate-url',
        meta: { title: 'Affiliate URL' },
        component: CreateAffiliateUrl
      },
      {
        path: '/order-opprovals',
        name: 'order-opprovals',
        meta: { title: 'Edited Orders' },
        component: EditedOrderView
      },
      {
        path: '/order-opproval-links/:id?',
        name: 'order-opproval-links',
        meta: { title: 'Edited Order Links' },
        component: EditedOrderLinksView
      },

    ],
  },
  // {
  //   path: '/email-verification',
  //   name: 'email-verification',
  //   component: EmailVerificationView,
  //   meta: {isAuthRequired: false},
  // },
  {
    path: '/503',
    name: '503',
    meta: { isAuthRequired: false },
    component: MaintenanceView
  },
  {
    path: '/invoice-payment',
    name: 'invoice-payment',
    meta: { isAuthRequired: false, title: 'Invoice Payment' },
    component: InvoicePaymentView
  },
  {
    path: '/:pathMatch(.*)*',
    component: NotFoundView,
    meta: { isAuthRequired: true, title: 'Page Not Found' }
  },
  {
    path: "/",
    redirect: (to) => ({ name: "login", query: to.query }),
    meta: { isAuthRequired: false },
    children: [
      {
        path: '/login',
        name: 'login',
        meta: { title: 'Log into LBHQ', description: 'Login to LinkBuilding HQ today to take advantage of white hat link building services. Boost your clients’ or your backlink profile with LinkBuilding HQ, today!' },
        component: LoginView
      },
      {
        path: '/register',
        name: 'signup',
        meta: { title: 'Register | LBHQ', description: 'Register to Link Building HQ today to gain premium backlinks for your clients or yourself. Signup for free, NO CREDIT CARD NEEDED. Quick and Easy registration.' },
        component: SignupView
      },
      {
        path: '/forget-password',
        name: 'forget',
        meta: { title: '' },
        component: ForgetView
      },
      {
        path: '/reset',
        name: 'reset',
        meta: { title: '' },
        component: ResetView
      },
      {
        path: '/accept-invitation',
        name: 'accept-invitation',
        meta: { title: '' },
        component: UserInvitationView
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; // Restore saved scroll position (e.g., on back/forward navigation).
    } else {
      return { top: 0 }; // Scroll to top for new navigations.
    }
  },
});

router.beforeEach((to, from, next) => {
  const fromRef = getRefFromQuery(from.query);
  if (isAuthPath(to.path) && !store.state.Auth.user.token && fromRef && !to.query?.ref) {
    next({
      path: to.path,
      query: { ...to.query, ref: fromRef },
      hash: to.hash,
      replace: true,
    });
    return;
  }

  if (to.meta.isAuthRequired && !store.state.Auth.user.token) {

    let params = withRouteRef(to.query, store.state.queryParamValue || {});

    if (to.name == 'product' || to.name == 'media-links-summary' || to.name == 'brand-mentions') {
      next({ name: 'signup', query: params });
      // }
      // else if(to.name == 'dashboard'){
      //   next({name: 'login', query: params });
    } else if (to.name == 'media-links') {
      // Keep intent so login/signup can return user to media-links after auth
      sessionStorage.setItem('post_auth_redirect', 'media-links');
      next({ name: 'signup', query: params });
    } else {
      next({ name: 'login', query: params });
      //   next({name: 'login'});
    }
  } else if (to.path !== '/503' && to.name !== 'invoice-payment' && store.state.Auth.user.token && !to.meta.isAuthRequired) {
    // Preserve query params (e.g. verification_code + UTMs from email links)
    next({ name: 'dashboard', query: to.query });
  } else {
    const existingMetaDescription = document.querySelector('meta[name="description"]');
    // Check if the meta tag exists before removing it
    if (existingMetaDescription) {
      // Remove the existing meta tag from the document head
      existingMetaDescription.remove();
    }
    if (to.path == '/login' || to.path == '/register') {
      document.title = `${to.meta.title}`;
      const metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      metaDescription.setAttribute('content', to.meta.description);
      document.head.appendChild(metaDescription);
    }
    else if (to.meta.title !== undefined && to.meta.title !== null && to.meta.title !== '') {
      document.title = `Link Building HQ - ${to.meta.title}`;
    } else {
      document.title = `Link Building HQ`;
    }
    next();
  }
});

export default router
